export function InfoIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path d="M10,1.78A8.22,8.22,0,1,0,18.22,10,8.23,8.23,0,0,0,10,1.78Zm0,14.79A6.57,6.57,0,1,1,16.57,10,6.58,6.58,0,0,1,10,16.57Z" />
      <path d="M10,8.14A.85.85,0,0,0,9.15,9v4.69a.85.85,0,0,0,1.7,0V9A.85.85,0,0,0,10,8.14Z" />
      <path d="M10,5.47a.94.94,0,1,0,.93.94A.94.94,0,0,0,10,5.47Z" />
    </svg>
  )
}
